const AZURE_API_VERSION = '2024-03-01';

async function azureRequest(path, token, subscriptionId) {
  const url = `https://management.azure.com/subscriptions/${subscriptionId}${path}?api-version=${AZURE_API_VERSION}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return null;
  return res.json();
}

export async function importFromAzure(accessToken, subscriptionId) {
  const result = { nodes: [], edges: [], errors: [] };

  let rgData;
  try {
    rgData = await azureRequest('/resourcegroups', accessToken, subscriptionId);
  } catch {
    result.errors.push('Failed to fetch resource groups. Check token and subscription ID.');
    return result;
  }

  if (!rgData?.value) {
    result.errors.push('No resource groups found in subscription.');
    return result;
  }

  const rgNodes = [];
  let x = 50;
  const y = 50;

  for (const rg of rgData.value) {
    const rgId = `rg-${rg.name}`;
    rgNodes.push({
      id: rgId,
      type: 'resource-group',
      position: { x, y },
      data: {
        type: 'resource-group',
        name: rg.name,
        region: rg.location,
      },
      style: { width: 220, height: 120 },
    });
    x += 280;

    try {
      const vnetData = await azureRequest(
        `/resourceGroups/${rg.name}/providers/Microsoft.Network/virtualNetworks`,
        accessToken,
        subscriptionId,
      );

      if (vnetData?.value) {
        let vnetX = x + 280;
        for (const vnet of vnetData.value) {
          const vnetId = `vnet-${vnet.name}`;
          const cidr = vnet.properties?.addressSpace?.addressPrefixes?.[0] || '10.0.0.0/16';
          result.nodes.push({
            id: vnetId,
            type: 'vnet',
            position: { x: vnetX, y: y + 150 },
            data: {
              type: 'vnet',
              name: vnet.name,
              cidr,
              region: vnet.location,
            },
            parentId: rgId,
            style: { width: 220, height: 120 },
          });

          const subnets = vnet.properties?.subnets || [];
          let snetX = vnetX + 280;
          for (const subnet of subnets) {
            const snetId = `snet-${subnet.name}`;
            const snetCidr = subnet.properties?.addressPrefix || '10.0.1.0/24';
            result.nodes.push({
              id: snetId,
              type: 'subnet',
              position: { x: snetX, y: y + 300 },
              data: {
                type: 'subnet',
                name: subnet.name,
                cidr: snetCidr,
              },
              parentId: vnetId,
              style: { width: 220, height: 120 },
            });
            snetX += 280;
          }
          vnetX += 280 + subnets.length * 280;
        }
      }
    } catch {
      // Skip VNets for this RG if fetch fails
    }

    try {
      const vmData = await azureRequest(
        `/resourceGroups/${rg.name}/providers/Microsoft.Compute/virtualMachines`,
        accessToken,
        subscriptionId,
      );

      if (vmData?.value) {
        let vmX = x;
        for (const vm of vmData.value) {
          const vmId = `vm-${vm.name}`;
          const sku = vm.properties?.hardwareProfile?.vmSize || 'Standard_B2s';
          result.nodes.push({
            id: vmId,
            type: 'virtual-machine',
            position: { x: vmX, y: y + 450 },
            data: {
              type: 'virtual-machine',
              name: vm.name,
              sku,
              region: vm.location,
            },
            parentId: rgId,
            style: { width: 220, height: 120 },
          });
          vmX += 280;
        }
      }
    } catch {
      // Skip VMs
    }
  }

  result.nodes = [...rgNodes, ...result.nodes];
  return result;
}
